<app-main-layout>
  <app-profile-page></app-profile-page>
</app-main-layout>
